// extracted by mini-css-extract-plugin
export default {"button":"button-S0DR6cul","arrow":"arrow-tpnd4xfh"};